<ng-container *ngTemplateOutlet="(selectedDeliveryType$ | async) === deliveryType.Delivery ? delivery : pickup"></ng-container>

<ng-template #pickup>
  <ng-container *ngIf="outlets$ | async as outlets">
    <ng-container *ngIf="outlets.length > 1; else singleOutlet">
      <div class="form">
        <div class="form__col _md">
          <mat-form-field appearance="outline" *ngIf="{activeOutletId: activeOutletId$ | async}">
            <mat-label i18n="@@SelectRestaurant">Select restaurant</mat-label>
            <mat-select #restoSelect (valueChange)="onChangeResto(restoSelect)" [formControl]="restoSelectCtrl">
              <mat-option
                class="mat-option-multiline"
                [value]="outlet.storeId"
                *ngFor="let outlet of outlets; let i = index"
              >{{ outlet.address }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <ng-template #singleOutlet>
      <div class="value-cell">
        <div class="value-cell__title h5" i18n="@@RestaurantAddress">Restaurant address</div>
        <div class="value-cell__text">{{ pickupAddress$ | async }}</div>
      </div>
    </ng-template>

  </ng-container>
</ng-template>

<ng-template #delivery>
  <ng-container *ngIf="addressFieldSettings$ | async as addressFieldSettings">
    <ng-container *ngIf="!addressFieldSettings.useAddressFormatType">
      <app-full-address-step [formControl]="form" *ngIf="!addressFieldSettings.usesIndexSearch"></app-full-address-step>
      <app-index-address-step [formControl]="form" *ngIf="addressFieldSettings.usesIndexSearch"></app-index-address-step>
    </ng-container>

    <app-hint-address-step [formControl]="form" *ngIf="addressFieldSettings.useAddressFormatType"></app-hint-address-step>
  </ng-container>
</ng-template>
